import styled from 'styled-components'

export default styled.form`
  width: 100%;
  font-size: 17px;
  color: #262626;
`
